export default __webpack_public_path__ + "dropzone-icon.png";